import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { EndpointFilterGzDataProvider } from '../dataProvider/EndpointFilterGzDataProvider';

export class EndpointFilterDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, EndpointFilterGzDataProvider);
  }
}
